const palette = {
  default: 'bg-bg-elevated border-border-strong text-slate-400',
  success: 'bg-emerald-400/10 border-emerald-400/30 text-emerald-400',
  warning: 'bg-amber-400/10 border-amber-400/30 text-amber-400',
  danger:  'bg-red-400/10 border-red-400/30 text-red-400',
  info:    'bg-sky-400/10 border-sky-400/30 text-sky-400',
};

export default function Badge({ children, variant = 'default' }) {
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-md border text-xs font-medium ${palette[variant]}`}>
      {children}
    </span>
  );
}
